import React from 'react';
export function TomoCards() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    color: 'bg-green-700',
    border: 'border-green-800',
    title: 'Gestión Rural',
    emoji: '🌾'
  }, {
    color: 'bg-blue-700',
    border: 'border-blue-800',
    title: 'Administración',
    emoji: '📊'
  }, {
    color: 'bg-amber-800',
    border: 'border-amber-900',
    title: 'Legislación',
    emoji: '⚖️'
  }, {
    color: 'bg-yellow-600',
    border: 'border-yellow-700',
    title: 'Contratos',
    emoji: '📄'
  }, {
    color: 'bg-emerald-600',
    border: 'border-emerald-700',
    title: 'Normativa Amb.',
    emoji: '🌱'
  }, {
    color: 'bg-red-700',
    border: 'border-red-800',
    title: 'Seguridad',
    emoji: '⚠️'
  }];
  return <section className="bg-white py-3 px-3 border-b border-gray-200" data-id="element-190">
      <div className="max-w-4xl mx-auto" data-id="element-191">
        <h3 className="text-center text-[#1F3D2B] font-black uppercase tracking-widest mb-2 text-xs md:text-sm" data-id="element-192">
          📘 VISTA RÁPIDA DE LOS 6 TOMOS
        </h3>
        <div className="flex gap-1.5 overflow-x-auto pb-1 scrollbar-hide justify-start md:justify-center" data-id="element-193">
          {tomos.map((tomo, i) => <div key={i} onClick={scrollToPricing} className={`${tomo.color} ${tomo.border} border-b-3 rounded-lg p-2 text-center cursor-pointer transform hover:-translate-y-1 hover:border-[#D4A843] transition-all duration-300 shadow-sm flex-shrink-0 w-[72px] md:w-24 flex flex-col justify-center items-center`} data-id="element-194">
              <div className="text-xl mb-0.5" data-id="element-195">{tomo.emoji}</div>
              <h4 className="text-white font-black text-[10px] md:text-xs leading-tight" data-id="element-196">
                {tomo.title}
              </h4>
            </div>)}
        </div>
      </div>
    </section>;
}